import React from "react";

const Privacy = () => (
  <div className="privacy-container" style={{ maxWidth: 700, margin: "2rem auto", background: "#fff", borderRadius: 12, padding: 32, boxShadow: "0 4px 12px rgba(0,0,0,0.07)" }}>
    <h2>🛡️ Política de Privacidad de PomTask</h2>
    <p><strong>Última actualización:</strong> 25 de junio de 2025</p>
    <p>
      PomTask valora tu privacidad. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información cuando te registras y usas nuestra aplicación.
    </p>
    <h3>1. ¿Qué información recopilamos?</h3>
    <ul>
      <li>Tu dirección de correo electrónico.</li>
      <li>Nombre de usuario o identificador único (si lo proporcionas).</li>
      <li>Datos de tus tareas, temporizadores y estadísticas de uso.</li>
      <li>Toda esta información se almacena de forma segura en Firebase (Google Cloud Platform).</li>
    </ul>
    <h3>2. ¿Cómo usamos tu información?</h3>
    <ul>
      <li>Identificarte y permitirte acceder a tu cuenta.</li>
      <li>Guardar tus tareas, progreso y configuraciones.</li>
      <li>Mejorar tu experiencia y personalizar la aplicación.</li>
      <li>Proporcionarte estadísticas de productividad y uso.</li>
    </ul>
    <h3>3. ¿Con quién compartimos tus datos?</h3>
    <ul>
      <li>No compartimos tus datos personales con terceros.</li>
      <li>Tus datos están almacenados en Firebase y solo tú puedes acceder a tu información personal desde tu cuenta.</li>
    </ul>
    <h3>4. ¿Dónde se almacenan los datos?</h3>
    <ul>
      <li>Los datos se almacenan en servidores seguros proporcionados por Firebase (Google LLC), con centros de datos en EE. UU. y Europa. Firebase cumple con el RGPD y otras regulaciones internacionales de privacidad.</li>
    </ul>
    <h3>5. ¿Cuáles son tus derechos?</h3>
    <ul>
      <li>Acceder a tus datos personales.</li>
      <li>Modificar o corregir tu información.</li>
      <li>Solicitar la eliminación de tu cuenta y datos asociados.</li>
      <li>Para ejercer estos derechos, puedes contactarnos en: <a href="mailto:pomtaskcontact@gmail.com">pomtaskcontact@gmail.com</a></li>
    </ul>
    <h3>6. Seguridad</h3>
    <p>
      Aplicamos medidas técnicas y organizativas para proteger tus datos contra accesos no autorizados, pérdida o destrucción. Usamos autenticación segura y conexión cifrada (HTTPS).
    </p>
    <h3>7. Cambios en esta Política</h3>
    <p>
      Podemos actualizar esta Política de Privacidad en el futuro. Notificaremos los cambios relevantes a través de la app o correo electrónico.
    </p>
    <h3>8. Contacto</h3>
    <p>
      Si tienes preguntas sobre esta política, puedes escribirnos a:<br />
      📧 <a href="mailto:pomtaskcontact@gmail.com">pomtaskcontact@gmail.com</a>
    </p>
  </div>
);

export default Privacy;